import styled from "styled-components";
import OrderFormRow from "./OrderFormRow";

export default styled(OrderFormRow)<{ $isCreditCard: boolean; }>`
  .ant-radio {
    align-self: flex-start !important;
    top: 4px !important;
  }

  .option-text {
    font-weight: 600;
  }

  .credit-card-info {
    display: flex;
    align-items: center;
    font-size: 12px;

    img {
      width: 100px;
    }
  }

  .bill-acount-info {

    input {
      width: 200px;
      background-color: ${props => props.$isCreditCard ? "#F5F5F5" : "#FFF"};
    }
  }

  .spacer {
    margin: 12px 0;
    content: ' ';
  }
`;
